import React, { useEffect, useState } from "react";
import { Modal, Button, Alert } from "react-bootstrap";
import { addtReturnOrder, getPopUpReturnOrders } from "../../network/api/order.js";
import ProfileCard from "./ProfileCard.js";

const ReturnForm = ({ show, setShowModal, onHide, setRefreshComponent, refreshComponent }) => {
  const [success, setSuccess] = useState("");
  const [orders, setOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    getPopUpReturnOrders().then((reponse) => {
      setOrders(reponse.data);
    });
  }, [refreshComponent]);
  const handleOrderSelection = (orderId) => {
    setSelectedOrder(orderId);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedOrder) {
      setError("Please choose an order before submitting."); // Set the error message
      setTimeout(() => {
        setError("");
      }, 2000);
      return; // Do not proceed with submission if an order is not selected
    }
    addtReturnOrder(selectedOrder)
      .then((response) => {
        setSuccess("order requested for return");
        setTimeout(() => {
          setSelectedOrder(null);
          setRefreshComponent((prev) => !prev);
          setSuccess("");
          onHide();
        }, 2000);
      })
      .catch((err) => {
        setError("something went error"); // Set the error message
      });
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" >
      <Modal.Body>
        <div className="frame-420-header d-flex justify-content-between px-2">
          <div className="mt-4">
            {!orders || orders.length === 0 ? <h4>لا يوجد منتجات لإسترجاعها</h4> : ""}
          </div>
          <button onClick={() => setShowModal(prev => !prev)}>
            <svg width="40" height="40" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.19526 3.13807C1.93491 2.87772 1.93491 2.45561 2.19526 2.19526C2.45562 1.93491 2.87772 1.93491 3.13807 2.19526L5.99999 5.05718L8.86189 2.19526C9.12225 1.93491 9.54438 1.93491 9.80473 2.19526C10.0651 2.45561 10.0651 2.87772 9.80473 3.13807L6.94279 5.99999L9.80473 8.86189C10.0651 9.12225 10.0651 9.54438 9.80473 9.80473C9.54438 10.0651 9.12225 10.0651 8.86189 9.80473L5.99999 6.94279L3.13807 9.80473C2.87772 10.0651 2.45562 10.0651 2.19526 9.80473C1.93491 9.54438 1.93491 9.12225 2.19526 8.86189L5.05718 5.99999L2.19526 3.13807Z" fill="#A5A5A5" />
            </svg>
          </button>
        </div>
        {orders?.map((order, index) => (
          <div className="profile-card mx-5">
            <div key={index} >
              <p className="fw-bolder ">Total: ${order.totalPrice}</p>
              <div className="mb-3">
                {order?.status && (
                  <div className="text-white ">
                    <span className="bg-success rounded p-1">
                      {order.status}
                    </span>
                  </div>
                )}
              </div>
              <input
                type="radio"
                style={{ border: "2px solid black" }}
                id={`orderRadio${index}`}
                name="orderRadio"
                value={order._id}
                checked={selectedOrder === order._id}
                onChange={() => handleOrderSelection(order._id)}
              />
              <label className="w-100" htmlFor={`orderRadio${index}`}>
                {order?.products?.map((product, productIndex) => (
                  <ProfileCard
                    key={productIndex}
                    image={product.image[0].secure_url}
                    title={product.name}
                    cate={product.category}
                    color={product.color}
                    size={product.size}
                    quantStart={product.quantity}
                    price={order.totalPrice}
                    oldPrice={product.oldPrice}
                    sale={product.sale}
                    status={order.status}
                  />
                ))}
              </label>
            </div>
          </div>
        ))}
        {success && (
          <div className="alert alert-success mt-1" role="alert">{success}</div>
        )}
        {error && <Alert variant="danger">{error}</Alert>}
      </Modal.Body>
      {!success && (
        <div className="d-flex justify-content-center gap-3 p-3">
          <Button style={{ backgroundColor: "#C99700", border: "none", marginRight: "5px" }} onClick={(event) => handleSubmit(event)}>
            متأكد
          </Button>
          <Button
            style={{ backgroundColor: "#C99700", border: "none" }}
            onClick={() => {
              onHide();
              setSelectedOrder(null);
            }}
          >
            إغلاق
          </Button>
        </div >
      )}
    </Modal >
  );
};

export default ReturnForm;
